import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/LOGO 1.png";
import "./navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  // State for mobile nav
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  // Change nav color when scrolling
  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 70) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);

  // Close menu on outside click
  const navRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (click && navRef.current && !navRef.current.contains(event.target)) {
        setClick(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [click]);

  // Close menu when a menu item is clicked
  const closeMenu = () => setClick(false);

  return (
    <div
      className={color ? "header header-bg z-20" : "header font-header z-20"}
    >
      <nav className="navbar" ref={navRef}>
        <Link to="" className="logo">
          <img
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            src={logo}
            alt="logo"
          />
        </Link>
        <div className="hamburger" onClick={handleClick}>
          {click ? (
            <FaTimes
              size={30}
              className={color ? "color-nav-mobile" : "font-header-2"}
            />
          ) : (
            <FaBars
              size={30}
              className={color ? "color-nav-mobile" : "font-header-2"}
            />
          )}
        </div>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <a
              href="#profil"
              onClick={(e) => {
                e.preventDefault(); // Prevent default anchor behavior
                document.querySelector("#profil").scrollIntoView({
                  behavior: "smooth", // Enable smooth scrolling
                  block: "start", // Scroll to the top of the target
                });
                closeMenu(); // Call your custom `closeMenu` function
              }}
            >
              Profil
            </a>
          </li>

          <li className="nav-item">
            <a
              href="#produk"
              onClick={(e) => {
                e.preventDefault(); // Prevent default anchor behavior
                document.querySelector("#produk").scrollIntoView({
                  behavior: "smooth", // Enable smooth scrolling
                  block: "start", // Scroll to the top of the target
                });
                closeMenu(); // Call your custom `closeMenu` function
              }}
            >
              Produk
            </a>
          </li>

          <li className="nav-item">
            <a
              href="#layanan"
              onClick={(e) => {
                e.preventDefault(); // Prevent default anchor behavior
                document.querySelector("#layanan").scrollIntoView({
                  behavior: "smooth", // Enable smooth scrolling
                  block: "start", // Scroll to the top of the target
                });
                closeMenu(); // Call your custom `closeMenu` function
              }}
            >
              Layanan
            </a>
          </li>

          {/* <li className="nav-item">
            <Link
              to="/layanan"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                closeMenu();
              }}
            >
              Produk
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/tips"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                closeMenu();
              }}
            >
              Layanan
            </Link>
          </li> */}
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
